import { defineComponent as _defineComponent } from 'vue'
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import { ref, computed } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { useBulkUnassignMutation } from '@/api/jobs'


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUnassignForm',
  props: {
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedJobs: JobJson[]
}





const showSnackBar = ref(false)

const { bulkUnassign, isLoading: saving, isError } = useBulkUnassignMutation()

const dismiss = () => emits('dismiss')
const clearSnackbar = () => (showSnackBar.value = false)

const buttonLabel = computed<string>(() => {
  const jobCount = props.selectedJobs.length
  return jobCount >= 2 ? `Unassign ${jobCount} jobs` : 'Unassign job'
})

const save = async () => {
  try {
    await bulkUnassign({
      jobIds: props.selectedJobs.map((job) => job.id),
    })
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        assigned_resource_id: null,
        assigned_service_provider_id: null,
      })
    )
    emits('updated', { message: 'Jobs Unassigned', updatedJobs })
  } catch (e) {
    showSnackBar.value = isError.value
  }
}

return { __sfc: true,emits, props, showSnackBar, bulkUnassign, saving, isError, dismiss, clearSnackbar, buttonLabel, save, BulkUpdateWrapper }
}

})